import { z } from "zod";
import { WORKBOOK_RUN_STEP_TIMEOUT } from "@erp/shared-types";
import { defineStepConfig } from "../../registry/helpers";
/**
 * A Workbook Run's Backing workflow step: executes a Run the editor already
 * captured. Internal plumbing, so hidden from the palette; automations use
 * Run Workbook (`run_workbook`).
 */
export const workbookTransformStep = defineStepConfig({
  type: "workbook_transform",
  name: "Execute Workbook Run",
  category: "Utility",
  description:
    "Execute a Workbook Run the editor captured, against its input snapshot. Results remain in object storage. Internal: use Run Workbook in workflows.",
  // Internal, not retired: marked deprecated because the node library and agent catalog hide
  // deprecated steps, which is what keeps authors on Run Workbook.
  deprecated: {
    reason: "Internal to Workbook runs. Use Run Workbook in workflows.",
    replacedBy: "run_workbook",
  },
  inputSchema: z.object({ workbookRunId: z.uuid() }),
  outputSchema: z.object({ workbookRunId: z.uuid(), resultKey: z.string() }),
  configSchema: z.object({}),
  emits: [] as const,
  execution: {
    // Capturing and computing a Large table (millions of rows) takes minutes.
    startToCloseTimeout: WORKBOOK_RUN_STEP_TIMEOUT,
    // Failed runs are terminal; an explicit rerun captures a new input snapshot.
    retry: { maximumAttempts: 1 },
  },
});
